function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { createRef, useMemo, useContext } from 'react';
import { injectIntl } from 'react-intl';
import './ArrayTemplate.css';
import tabbable from 'tabbable';
import cs from 'classnames';
import I18n, { formatI18n } from '../../I18n/I18n/I18n';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import en from './locales/ArrayTemplate.en.json';
import Draggable from '../../DragNDrop//Draggable/Draggable';
import SimpleDropZone from '../../DragNDrop/SimpleDropZone/SimpleDropZone';
import DragHandle from '../../FormBuilder/DragHandle/DragHandle';
import ActionsMenu from './ActionsMenu/ActionsMenu';
import ThemeContext from '../../ThemeContext';
import SemanticSection from '../../SemanticSection/SemanticSection';
import H from '../../H/H';
import Icon from '../../Icons/Icon/Icon';
import { ReactComponent as Plus } from '../../../icons/Plus/Plus.svg';
import WidgetSizeContext from '../WidgetSizeContext/WidgetSizeContext';
import ExpandArraysContext from '../ExpandArraysContext';
import ValidateErrorsContext from '../ValidationForm/ValidateErrorsContext';
import { LabelIcons } from '../Widgets/utils/getLabelIcons';
import { LazyContainerState } from '../../LazyContainer/LazyContainer';
import { WmButton } from '@watermarkinsights/ripple-react';
var messages = normalizeLocaleData(en, '@dm/components.arrayTemplate');
function getItemActionFlags(arrayActions, item) {
  return {
    canAdd: arrayActions.canAdd,
    canDelete: arrayActions.canRemove && item.hasRemove,
    canMove: arrayActions.canMove && (item.hasMoveUp || item.hasMoveDown)
  };
}
function getTextProps(uiSchema, uiSchemaProp, defaultText) {
  var result = {
    text: defaultText
  };
  if (uiSchema[uiSchemaProp]) {
    var uiText = uiSchema[uiSchemaProp];
    if (typeof uiText === 'object') {
      result.text = uiText.text || defaultText;
      result.escape = uiText.escape;
    } else {
      result.text = uiText;
    }
  }
  return result;
}
function hasItemName(uiSchema) {
  return uiSchema['ui:options'] && uiSchema['ui:options'].itemName && uiSchema['ui:options'].itemName.trim().length > 0;
}
function getTitleProps(uiSchema, defaultTitle) {
  var _default = defaultTitle;
  if (!defaultTitle || defaultTitle.trim().length === 0) {
    _default = hasItemName(uiSchema) ? uiSchema['ui:options'].itemName : '@dm/components.arrayTemplate.label';
  }
  return getTextProps(uiSchema, 'ui:title', _default);
}
function getDescriptionProps(uiSchema, defaultDescription) {
  var descriptionProps = getTextProps(uiSchema, 'ui:description', defaultDescription || '');
  return descriptionProps.text.length > 0 ? descriptionProps : undefined;
}
var BaseItemHeader = function BaseItemHeader(_ref) {
  var arrayActions = _ref.arrayActions,
    focusOnRow = _ref.focusOnRow,
    id = _ref.id,
    item = _ref.item,
    itemName = _ref.itemName,
    items = _ref.items,
    rowNumber = _ref.rowNumber,
    intl = _ref.intl;
  var i18n = useMemo(function () {
    var _itemName = itemName && itemName.trim().length ? itemName : formatI18n(intl, '@dm/components.arrayTemplate.item');
    return {
      id: '@dm/components.arrayTemplate.itemName',
      values: {
        itemName: _itemName,
        rowNumber: rowNumber
      }
    };
  }, [intl, itemName, rowNumber]);
  var flags = getItemActionFlags(arrayActions, item);
  return /*#__PURE__*/React.createElement("div", {
    className: "_dm-form-dsa-item-header"
  }, /*#__PURE__*/React.createElement(H, {
    id: id,
    className: "_dm-form-dsa-item-header__label"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  })), (flags.canAdd || flags.canDelete || flags.canMove) && /*#__PURE__*/React.createElement(ActionsMenu, {
    item: item,
    itemI18n: i18n,
    flags: flags,
    items: items,
    focusOnRow: focusOnRow
  }));
};
var ItemHeader = injectIntl(BaseItemHeader);
function ArrayItems(_ref2) {
  var arrayId = _ref2.arrayId,
    arrayActions = _ref2.arrayActions,
    focusOnRow = _ref2.focusOnRow,
    itemName = _ref2.itemName,
    items = _ref2.items,
    widgetSize = _ref2.widgetSize,
    isPrintView = _ref2.isPrintView,
    isCardView = _ref2.isCardView;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item, index) {
    var dsaId = "dsa-header-".concat(item.key);
    return /*#__PURE__*/React.createElement("div", {
      key: item.key,
      className: getArrayItemClassNames(widgetSize, arrayId, item, isPrintView, isCardView, theme),
      role: "group",
      "aria-labelledby": dsaId
    }, /*#__PURE__*/React.createElement(ItemHeader, {
      arrayActions: arrayActions,
      focusOnRow: focusOnRow,
      id: dsaId,
      item: item,
      itemName: itemName,
      items: items,
      rowNumber: index + 1
    }), /*#__PURE__*/React.createElement(SemanticSection, null, item.children));
  }));
}
function getArrayItemClassNames(widgetSize, arrayId, item, isPrintView, isCardView, theme) {
  return cs('_dm-form-dsa-item', "_dm-form-dsa-item--".concat(theme), "_dm-form-dsa-item--".concat(widgetSize), {
    '_dm-form-dsa-item--print': isPrintView,
    '_dm-form-dsa-item--card': isCardView
  }, 'auto-field-set-item', "auto-field-set-item--".concat(arrayId, "-").concat(item.index), "auto-field-set-item--".concat(item.index));
}
function DraggableArrayItems(_ref3) {
  var widgetSize = _ref3.widgetSize,
    itemName = _ref3.itemName,
    arrayId = _ref3.arrayId,
    arrayActions = _ref3.arrayActions,
    items = _ref3.items,
    onUpdateOrder = _ref3.onUpdateOrder,
    onDragEnd = _ref3.onDragEnd,
    focusOnRow = _ref3.focusOnRow,
    isPrintView = _ref3.isPrintView,
    isCardView = _ref3.isCardView;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(SimpleDropZone, {
    items: items,
    onUpdateOrder: onUpdateOrder,
    onDragEnd: onDragEnd
  }, function () {
    return items.map(function (item, index) {
      var dsaId = "dsa-header-".concat(item.key);
      return /*#__PURE__*/React.createElement(Draggable, {
        key: "".concat(item.key, "-").concat(index),
        draggableId: "draggable-".concat(index),
        index: index
      }, function (provided) {
        return /*#__PURE__*/React.createElement("div", Object.assign({
          ref: provided.innerRef
        }, provided.draggableProps, {
          className: getArrayItemClassNames(widgetSize, arrayId, item, isPrintView, isCardView, theme),
          role: "group",
          "aria-labelledby": dsaId
        }), /*#__PURE__*/React.createElement(ItemHeader, {
          arrayActions: arrayActions,
          focusOnRow: focusOnRow,
          id: dsaId,
          item: item,
          itemName: itemName,
          items: items,
          rowNumber: index + 1
        }), /*#__PURE__*/React.createElement(DragHandle, {
          dragHandleProps: provided.dragHandleProps,
          describedby: dsaId
        }), /*#__PURE__*/React.createElement(SemanticSection, null, item.children));
      });
    });
  });
}
export function isEmpty(formData) {
  if (Array.isArray(formData)) {
    return undefined === formData.find(function (el) {
      return !isEmpty(el);
    });
  } else if (typeof formData === 'object' && formData !== null) {
    return undefined === Object.keys(formData).find(function (key) {
      return key !== 'id' && !isEmpty(formData[key]);
    });
  }
  return formData === '' || formData === null || formData === undefined;
}
var ArrayTitleField = function ArrayTitleField(props) {
  var arrayProps = props.arrayProps,
    expandArrays = props.expandArrays,
    errors = props.errors,
    onAddClick = props.onAddClick,
    onUpdateOrder = props.onUpdateOrder,
    onDragEnd = props.onDragEnd,
    focusOnRow = props.focusOnRow,
    titleId = props.titleId,
    arrayId = props.arrayId,
    labelIcons = props.labelIcons;
  var TitleField = arrayProps.TitleField,
    DescriptionField = arrayProps.DescriptionField,
    formData = arrayProps.formData,
    formContext = arrayProps.formContext,
    schema = arrayProps.schema,
    uiSchema = arrayProps.uiSchema,
    idSchema = arrayProps.idSchema,
    items = arrayProps.items;
  var defaultOpen = expandArrays.defaultOpen,
    openOnError = expandArrays.openOnError;
  var isPrintView = formContext.isPrintView,
    isCardView = formContext.isCardView;
  var title = getTitleProps(uiSchema, arrayProps.title);
  var description = getDescriptionProps(uiSchema, schema.description);
  var uiSchemaOptions = uiSchema['ui:options'] || {};
  var itemName = uiSchemaOptions.itemName || '';
  var isOrderable = isPrintView || arrayProps.disabled ? false : uiSchemaOptions.orderable !== false;
  var hasItems = !!(items && items.length);
  var numItems = hasItems ? items.length : 0;
  var maxItems = schema.maxItems;
  var minItems = schema.minItems !== undefined ? schema.minItems : 1;
  var arrayActions = isPrintView || arrayProps.disabled ? {} : {
    canAdd: arrayProps.canAdd && (maxItems !== undefined ? numItems < maxItems : true),
    canRemove: numItems > minItems,
    canMove: isOrderable && numItems !== 1
  };
  var defaultOpenOrEmpty = useMemo(function () {
    // Per PRO-6643 empty arrays should always be expanded
    return defaultOpen || isEmpty(formData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var expandForErrors = useMemo(function () {
    var result = false;
    var $id = idSchema.$id;
    if (openOnError && $id && $id.length && errors.length) {
      var id = $id.indexOf('_') === 0 ? $id.substring(1) : $id;
      var dsaErrors = errors.filter(function (error) {
        return error.property && error.property.indexOf(".".concat(id, "[")) !== -1;
      });
      result = dsaErrors.length > 0;
    }
    return result;
  }, [openOnError, errors, idSchema]);
  return /*#__PURE__*/React.createElement(TitleField, {
    className: "auto-field-set-label",
    dsa: true,
    defaultOpen: defaultOpenOrEmpty,
    expandForErrors: expandForErrors,
    id: titleId || "".concat(idSchema.$id, "__title"),
    idSchema: idSchema,
    groupUiIcons: labelIcons,
    text: title.text,
    escape: title.escape,
    help: uiSchema ? uiSchema['ui:help'] : '',
    description: description,
    DescriptionField: DescriptionField,
    itemCount: items ? items.length : 0,
    formContext: formContext
  }, /*#__PURE__*/React.createElement(SemanticSection, null, /*#__PURE__*/React.createElement(WidgetSizeContext.Consumer, null, function (widgetSize) {
    return items && (widgetSize !== 'small' && isOrderable ? /*#__PURE__*/React.createElement(DraggableArrayItems, {
      arrayId: arrayId,
      arrayActions: arrayActions,
      focusOnRow: focusOnRow,
      itemName: itemName,
      items: arrayProps.items,
      onDragEnd: onDragEnd,
      onUpdateOrder: onUpdateOrder,
      widgetSize: widgetSize,
      isPrintView: isPrintView,
      isCardView: isCardView
    }) : /*#__PURE__*/React.createElement(ArrayItems, {
      arrayId: arrayId,
      arrayActions: arrayActions,
      focusOnRow: focusOnRow,
      itemName: itemName,
      items: arrayProps.items,
      widgetSize: widgetSize,
      isPrintView: isPrintView,
      isCardView: isCardView
    }));
  }), arrayActions.canAdd && /*#__PURE__*/React.createElement("div", {
    className: "_dm-form-dsa__add ".concat(isCardView ? '_dm-form-dsa__add--card' : '')
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: "ripple"
  }, /*#__PURE__*/React.createElement(WmButton, {
    buttonType: "textonly",
    onClick: onAddClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "_dm-button _dm-button--ripple auto-action-button--add auto-action-button--ripple"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: 13,
    height: 13,
    className: "_dm-form-dsa__add-icon",
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(Plus, {
    width: 13,
    height: 13
  }))), /*#__PURE__*/React.createElement(I18n, {
    i18n: {
      id: '@dm/components.arrayTemplate.add',
      values: {
        itemName: itemName
      }
    }
  }))))));
};
export var ArrayFieldTemplate = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayFieldTemplate, _React$Component);
  function ArrayFieldTemplate(props) {
    var _this;
    _classCallCheck(this, ArrayFieldTemplate);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ArrayFieldTemplate).call(this, props));
    _this.dsaRef = void 0;
    _this.focusOnRowIndex = void 0;
    _this.focusOnRowActiveElement = void 0;
    _this.timeoutId = void 0;
    _this.focusOnRow = function (index) {
      _this.focusOnRowIndex = index;
      _this.focusOnRowActiveElement = document.activeElement;
    };
    _this._focusOnRow = function (index) {
      var ref = _this.dsaRef.current;
      if (ref) {
        var rows = ref.querySelectorAll('._dm-form-dsa-item');
        if (rows.length === 0) {
          return;
        }
        var row = index === rows.length ? rows[index - 1] : rows[index];
        if (row) {
          var _tabbable = tabbable(row),
            _tabbable2 = _slicedToArray(_tabbable, 1),
            firstTabbable = _tabbable2[0];
          var id = firstTabbable.id;
          clearTimeout(_this.timeoutId.current);
          _this.timeoutId.current = window.setTimeout(function () {
            var toFocus = document.getElementById(id);
            var activeElement = document.activeElement;
            if (_this.focusOnRowActiveElement === null || _this.focusOnRowActiveElement === activeElement || activeElement === document.body) {
              toFocus && toFocus.focus();
            }
          }, 100);
        }
      }
    };
    _this.onAddClick = function () {
      var fakeEvent = {
        preventDefault: function preventDefault() {}
      };
      _this.focusOnRow(_this.props.items.length);
      _this.props.onAddClick(fakeEvent);
    };
    // called when move via drag handle using mouse is complete
    _this.onDragEnd = function (update) {
      if (!update || !update.source || !update.destination) {
        return;
      }
      var startIndex = update.source.index;
      var endIndex = update.destination.index;
      var movedItem = _this.props.items[startIndex];
      movedItem.onReorderClick(startIndex, endIndex)(false); // false = no event
    };
    _this.onUpdateOrder = function () {};
    _this.dsaRef = createRef();
    _this.timeoutId = createRef();
    _this.focusOnRowIndex = 0;
    _this.focusOnRowActiveElement = null;
    return _this;
  }
  _createClass(ArrayFieldTemplate, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var _rowIndex = this.focusOnRowIndex;
      if (_rowIndex !== undefined && prevProps.items.length !== this.props.items.length) {
        this.focusOnRowIndex = 0;
        setTimeout(function () {
          _this2._focusOnRow(_rowIndex);
        }, 0);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // In the case of adding a row, react-jsonschema-form will trigger two updates:
      //   1. It will recalculate the item keys
      //   2. It will send the new array item
      return !this.focusOnRowIndex || nextProps.items.length !== this.props.items.length;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        disabled = _this$props.disabled,
        idSchema = _this$props.idSchema,
        uiSchema = _this$props.uiSchema,
        formContext = _this$props.formContext;
      var titleId = "".concat(idSchema.$id, "__title");
      var id = idSchema.$id;
      var arrayId = id.indexOf('_') === 0 ? id.substring(1) : id;
      return /*#__PURE__*/React.createElement(LazyContainerState, null, /*#__PURE__*/React.createElement(LabelIcons, {
        titleId: titleId,
        formContext: formContext,
        uiSchema: uiSchema
      }, function (_ref4) {
        var labelledBy = _ref4.labelledBy,
          labelIcons = _ref4.labelIcons;
        return /*#__PURE__*/React.createElement("div", {
          ref: _this3.dsaRef,
          id: "container-".concat(arrayId),
          className: cs('_dm-form-dsa', _this3.props.className, 'auto-field-set', _defineProperty({
            '_dm-form-dsa--card': formContext.isCardView,
            '_dm-form-dsa--card-disabled': formContext.isCardView && disabled
          }, "auto-field-set--".concat(arrayId), id && id.length)),
          role: "group",
          "aria-labelledby": labelledBy
        }, /*#__PURE__*/React.createElement(ExpandArraysContext.Consumer, null, function (expandArraysContext) {
          return /*#__PURE__*/React.createElement(ValidateErrorsContext.Consumer, null, function (errors) {
            return /*#__PURE__*/React.createElement(ArrayTitleField, {
              titleId: titleId,
              arrayId: arrayId,
              arrayProps: _this3.props,
              labelIcons: labelIcons,
              expandArrays: expandArraysContext,
              errors: errors,
              onAddClick: _this3.onAddClick,
              onDragEnd: _this3.onDragEnd,
              onUpdateOrder: _this3.onUpdateOrder,
              focusOnRow: _this3.focusOnRow
            });
          });
        }));
      }));
    }
  }]);
  return ArrayFieldTemplate;
}(React.Component);
export default withAdditionalIntl(messages)(ArrayFieldTemplate);